module.exports = __webpack_public_path__ + "img/x.8292edec.svg";